<script>
    import DrawerPanel from '../widget/DrawerPanel.svelte'

    // Note: these breakpoints come from the Bootstrap default layout breakpoints
    // https://getbootstrap.com/docs/5.0/layout/breakpoints/
    // If we use a theme that changes the breakpoints (unlikely) we will need
    // to update these values to match.
    const breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400
    }
    const breakpointForMobile = 'md'
    const drawerSizes = {
        xs: '80%',
        sm: '480px',
        md: '300px',
        lg: '300px',
        xl: '300px',
        xxl: '300px'
    }
    const getBreakpoint = (pixels) => {
        if (pixels > breakpoints.xxl) return 'xxl'
        if (pixels > breakpoints.xl) return 'xl'
        if (pixels > breakpoints.lg) return 'lg'
        if (pixels > breakpoints.md) return 'md'
        if (pixels > breakpoints.sm) return 'sm'
        return 'xs'
    }

    export let open = true
    export let scrim = false
    export let bgColor = '#000'
    export let fontColor = '#fff'

    let windowWidth
    let drawerWidth
    let breakpoint
    $: breakpoint = getBreakpoint(windowWidth)
    $: drawerWidth = drawerSizes[breakpoint]
    $: scrim = windowWidth < breakpoints[breakpointForMobile]
    $: marginLeft = !open || windowWidth < breakpoints[breakpointForMobile] ? '0' : drawerSizes[breakpoint]
</script>

<svelte:window bind:innerWidth={windowWidth} />

<DrawerPanel {open} size={drawerWidth} {bgColor} {fontColor} {scrim} on:clickAway={() => (open = false)}>
    <slot name="panel" />
</DrawerPanel>

<div style="margin-left: {marginLeft};">
    <slot name="content" />
</div>
